<hc-modal>
    <hc-modal-header>
        <span class="icon-left {{ isEdit ? 'icon-calendar-edit' : 'icon-calendar-clock-add' }}"></span>
        {{ isEdit ? 'Edit' : 'Create' }} Schedule
    </hc-modal-header>
    <form [formGroup]="tenantScheduleForm">
        <div class="cdp-modal-tab-content">
            <hc-form-field>
                <hc-label
                    >Name
                    <span class="icon-info cdp-info-ico cdp-info-ico-right" [hcTooltip]="descriptionHelp"></span>
                    <button
                        *ngIf="tenantScheduleForm.controls['description'].value !== currentCronStr"
                        hc-button
                        buttonStyle="link"
                        size="sm"
                        (click)="setNameToMatchCron()"
                        class="match-cadence-btn cdp-fade-in"
                        title="Change name to match the schedule's cadence description"
                    >
                        Match name to cadence
                    </button>
                </hc-label>
                <input hcInput maxlength="255" formControlName="description" [required]="true" />
                <hc-error> Tenant schedule description is required. </hc-error>
            </hc-form-field>
            <hc-form-field>
                <hc-slide-toggle sideLabel="Active" formControlName="activeFlag" [insideLabel]="'yes'">
                </hc-slide-toggle>
                <span class="icon-right icon-info cdp-info-ico" [hcTooltip]="activeFlagHelp"> </span>
            </hc-form-field>
            <cdp-cron-editor
                [formGroup]="tenantScheduleForm"
                controlName="cron"
                (cronChanged)="onCronChanged($event)"
            ></cdp-cron-editor>
            @if (showScheduleDeactiveWarning) {
                <div class="cdp-warn-chip-container">
                    <hc-chip color="yellow" width="100%">
                        <div class="cdp-warn-message-container">
                            <hc-icon class="icon-warn" hcIconSm></hc-icon>
                            <div>
                                This schedule is still used by {{ activeIngestionJobCount }} entities with active
                                status.
                            </div>
                        </div>
                    </hc-chip>
                </div>
            }
        </div>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="cancel()">Cancel</button>
            <button
                hc-button
                buttonStyle="primary"
                (click)="save()"
                [disabled]="!tenantScheduleForm.valid || saveInProgress"
            >
                <span *ngIf="!saveInProgress">
                    <ng-container *ngIf="!isEdit">Create schedule</ng-container>
                    <ng-container *ngIf="isEdit">Save</ng-container>
                </span>
                <hc-progress-dots color="light" [isMini]="true" [isCentered]="false" *ngIf="saveInProgress">
                </hc-progress-dots>
                <div *ngIf="saveInProgress">Saving...</div>
            </button>
        </hc-modal-footer>
    </form>
</hc-modal>
